import {mapOverlayPanes} from "base/component/geo";
import {useLayerObjectWithLegend} from "base/map";
import {useNavigate} from "react-router-dom";

export function useLayer(detail = false) {
    const navigate = useNavigate();

    return useLayerObjectWithLegend({
        legendOptions: {
            layerName: "Bacía",
            defaultMarkerOptions: {
                marker: "l",
                addStroke: false,
                fontSize: 35,
                weight: 2,
                color: "lightblue",
                opacity: 1,
                lineJoin: "round",
                pane: mapOverlayPanes[1],
            },
        },
        layerOptions: {
            detail: detail,
            getTooltip: ({feature}) => {
                let data = feature.properties;
                let tooltip = `<b>Bacía: ${
                    data["nome"] ? data["nome"] : "---"
                }</b><ul class="attributes">`;
                tooltip += `<li><i>Código</i>: ${
                    data["codigo"] ? data["codigo"] : "---"
                }</li>`;
                tooltip += `<li><i>Categoría</i>: ${
                    data["categoria_label"] ? data["categoria_label"] : "---"
                }</li>`;
                tooltip += `<li><i>Demarcación</i>: ${
                    data["demarcacion_label"] ? data["demarcacion_label"] : "---"
                }</li>`;
                return tooltip + "</ul>";
            },
            defaultOnClick: ({feature}) => navigate(`info/masasauga/${feature.id}`),
        },
    });
}
